import PropTypes, { oneOf } from 'prop-types'

import { OptiDriveEventExclusionReasonType } from '../../models/opti-drive/opti-drive-event-exclusion-reason-type.js'
import { OptiDriveEventState } from '../../models/opti-drive/opti-drive-event-state.js'
import { OptiDriveEventType } from '../../models/opti-drive/opti-drive-event-type.js'

export const optiDriveEventExclusionPropType = PropTypes.shape({
    eventId: PropTypes.string.isRequired,
    eventType: oneOf(Object.values(OptiDriveEventType)).isRequired,
    exclusionState: oneOf(Object.values(OptiDriveEventState)),
    exclusionReasonType: oneOf(Object.values(OptiDriveEventExclusionReasonType)),
    exclusionComment: PropTypes.string,
    recoveryComment: PropTypes.string
})
